// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"52f824bb","188":"bd8b740d","275":"c9e07376","292":"38b91b3f","332":"560be794","452":"322c0482","609":"72b7a28f","638":"0cce6841","911":"30cb56ff"}[chunkId] + ".chunk.js";
};